import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiCheckSquare, FiClipboard, FiFile, FiInfo, FiTarget } from "react-icons/fi";
import { allUnits } from "../../../components/Unit";
import { ReusedProduct } from "../../../db_access/reused_product";
import ResizableTextBox from "../../../components/input/ResizableTextBox";
import TextBox from "../../../components/input/TextBox";
import { useContextProvider } from "../../../components/page-context/ContextProvider";
import { TableHeaderContainer } from "../../../components/container/TableHeaderContainer";
import { TableTitleContainer } from "../../../components/container/TableTitleContainer";
import FormSelect from "../../../components/select/FormSelect";
import muiSytle from "../../../style/components-style/muiStyle";
const ReusedProductScopeAndGoals = ({ reusedProduct }) => {
  const { t } = useTranslation();
  const { isSaveClicked, setIsSaveVisible, setIsSaveClicked, setIsLoading, setRefresh } = useContextProvider();

  const [formData, setFormData] = useState({
    name: "",
    functional_unit: "",
    other_unit: "",
    scope: "",
    goals: "",
    service_life: "",
    specifications: "",
    assumptions: "",
    system_boundary: "",
    epd_link: "",
    pcr_link: "",
  });

  const [modified, setModified] = useState(false);

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    setIsSaveVisible(true);
    setModified(true);
  };
  const reset = async () => {
    if (formData && formData.id) {
      ReusedProduct.resetScopeAndGoals(formData.id).finally(() => {
        setModified(false);
        setIsSaveVisible(false);
        setRefresh((r) => !r);
      });
    }
  };

  useEffect(() => {
    const cleanData = {};
    if (reusedProduct) {
      Object.keys(reusedProduct).forEach((k) => {
        cleanData[k] = (reusedProduct[k] === null || reusedProduct[k] === "null") ? "" : reusedProduct[k];
      });
    }
    setFormData(cleanData);
    setModified(false);
  }, [reusedProduct]);
  useEffect(() => {
    if (isSaveClicked && modified) {
      ReusedProduct.updateScopeAndGoals(formData)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to update");
          return res.json();
        })
        .catch((err) => {
          console.error("Error:", err);
        })
        .finally((_) => {
          setModified(false);
          setIsSaveClicked(false);
          setIsLoading(false);
          setRefresh((r) => !r);
        });
    }
  }, [isSaveClicked, modified, formData, setIsSaveClicked, setIsLoading, setRefresh]);

  return (
    <Paper variant="Table Container">
      <TableHeaderContainer>
        <TableTitleContainer>
          <Typography variant="Table Title">{t("Scope and Goals")}</Typography>
        </TableTitleContainer>
      </TableHeaderContainer>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box style={{ flex: 1 }}>
              <TextBox Icon={FiFile} label={"Name"} placeholder={"Name"} value={formData.name} onChange={handleChange("name")} disabled={formData.isEpd} />
            </Box>
            <Box style={{ flex: 1 }}>
              <FormSelect
                Icon={FiClipboard}
                label={"Functional Unit"}
                placeholder={"Functional Unit"}
                options={allUnits}
                value={formData.functional_unit}
                onChange={handleChange("functional_unit")}
                disabled={formData.isEpd}
              />
            </Box>
            {formData.functional_unit === "other" && (
              <Box style={{ flex: 1 }}>
                <TextBox Icon={FiFile} label={"Custom Unit"} placeholder={"Specify other functional unit"} value={formData.other_unit} onChange={handleChange("other_unit")} disabled={formData.isEpd} />
              </Box>
            )}
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box style={{ flex: 1 }}>
              <ResizableTextBox Icon={FiTarget} label={"Scope"} placeholder={"Scope"} value={formData.scope} onChange={handleChange("scope")} disabled={formData.isEpd} />
            </Box>
            <Box style={{ flex: 1 }}>
              <ResizableTextBox Icon={FiCheckSquare} label={"Goals"} placeholder={"Goals"} value={formData.goals} onChange={handleChange("goals")} disabled={formData.isEpd} />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box style={{ flex: 1 }}>
              <ResizableTextBox
                Icon={FiInfo}
                label={"Assumptions"}
                placeholder={"Assumptions"}
                value={formData.assumptions}
                onChange={handleChange("assumptions")}
                disabled={formData.isEpd}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box style={{ flex: 1 }}>
              <ResizableTextBox
                Icon={FiTarget}
                label={"System Boundary"}
                placeholder={"System Boundary"}
                value={formData.system_boundary}
                onChange={handleChange("system_boundary")}
                disabled={formData.isEpd}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default ReusedProductScopeAndGoals;
